import { BaseFlowFormService } from '@/modules/core/form/services/BaseFlowFormService';
import ToolsModal from '@/modules/admin/components/stateful/resource/ToolsModal.vue';
import { Component } from 'vue';
import ModalService from '@/modules/core/ui/services/ModalService';
import BaseFlowModal from '@/modules/core/form/components/BaseFlowModal.vue';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ComponentForm } from '@/modules/admin/models/ComponentForm';

export class ToolsModalFlowService extends BaseFlowFormService {
  getFirstComponent(): Component {
    return ToolsModal;
  }

  getModel(): BaseModel {
    return ComponentForm;
  }

  getRoute(): string {
    return '';
  }

  static show(parent: Component): void {
    ModalService.show({
      component: BaseFlowModal,
      parent,
      props: {
        customForm: {},
        service: new ToolsModalFlowService(),
        width: '100%'
      },
      fullScreen: true,
      hasModalCard: true
    });
  }
}
